import React from "react";
import AdminContainer from "../layouts/AdminContainer";
import AdminAuthContainer from "../layouts/AdminAuthContainer";
import { createRoute, createIndexRoute } from "./helpers";

const adminDashboardRoutes = {
  path: "/admin",
  element: <AdminContainer />,
  children: [
    createIndexRoute("Admin/Home/AdminHome"),
    createRoute("users", "Admin/Users/AdminUsers"),
    createRoute("subscribers", "Admin/Subscribers/AdminSubscribers"),
    createRoute("users/pending-deletion", "Admin/Users/PendingDeletions"),
    createRoute("wills", "Admin/Wills/AdminWills"),
    createRoute("transactions", "Admin/Transactions/AdminTransactions"),
    createRoute("contact-us", "Admin/ContactMessages/AdminContactMessages"),
    createRoute("audit-logs", "Admin/AuditLogs/AdminAuditLogs"),
    createRoute("documents", "Admin/Documents/AdminDocuments"),
    createRoute("plans", "Admin/Plans/AdminPlans"),
    createRoute("designations", "Admin/Designations/AdminDesignations"),
  ],
};

const adminAuthRoutes = {
  path: "/admin/auth",
  element: <AdminAuthContainer />,
  children: [
    createRoute("login", "Admin/Auth/AdminLogin"),
    createRoute("forgot-password", "Admin/Auth/AdminForgotPassword"),
    createRoute("new-password", "Admin/Auth/AdminNewPassword"),
    createRoute("reset-successful", "Admin/Auth/AdminResetSuccessful"),
  ],
};

export { adminDashboardRoutes, adminAuthRoutes };
